var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBuildingsKeepWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 620,
    viewBox: "0 0 580 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.667 157.222H152.222M121.667 248.889H152.222M274.444 248.889H305M274.444 340.556H305M121.667 340.556H152.222M274.444 157.222H305M152.222 585V493.333C152.222 459.582 179.583 432.222 213.333 432.222C231.584 432.222 247.968 440.225 259.167 452.911M396.667 401.667V83.8889C396.667 66.7762 396.667 58.2198 393.336 51.6836C390.406 45.9343 385.734 41.2599 379.983 38.3302C373.447 35 364.892 35 347.778 35H78.8889C61.7762 35 53.2198 35 46.6836 38.3302C40.9343 41.2599 36.2599 45.9343 33.3303 51.6836C30 58.2198 30 66.7762 30 83.8889V585H259.167M366.111 523.889L427.222 585L549.444 462.778",
    stroke: "white",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBuildingsKeepWhite);
export default __webpack_public_path__ + "static/media/ico_buildings_keep_white.9257cfff776c02bf3dc6a05dbaab5ceb.svg";
export { ForwardRef as ReactComponent };